import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 5000 }
  }

  connect() {
    if (this.hasProcessingStatements()) {
      this.scheduleNextPoll()
    }
  }

  disconnect() {
    this.cancelNextPoll()
  }

  hasProcessingStatements() {
    const frame = this.element.querySelector("#statements_list")
    return frame?.dataset.processing === "true"
  }

  scheduleNextPoll() {
    this.timeoutId = setTimeout(() => this.poll(), this.intervalValue)
  }

  cancelNextPoll() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "text/html",
          "Turbo-Frame": "statements_list",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        }
      })

      if (response.ok) {
        const html = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newFrame = doc.getElementById("statements_list")
        const currentFrame = this.element.querySelector("#statements_list")

        if (newFrame && currentFrame) {
          currentFrame.innerHTML = newFrame.innerHTML
          currentFrame.dataset.processing = newFrame.dataset.processing
        }
      }
    } catch (error) {
      console.error("Statement polling error:", error)
    }

    if (this.hasProcessingStatements()) {
      this.scheduleNextPoll()
    }
  }
}
